"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Star_1 = require("./Star");
exports.default = Star_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StarRating/components/Star/index.js
// module id = 672
// module chunks = 8